import UserDetail from "@/components/Details/UserDetail";
import UserManagementForm from "@/components/Forms/UserManagementForm";

const UserManagementUpdate = () => {
    return <UserManagementForm  />;
}

export default UserManagementUpdate;